import { jsx as _jsx } from 'react/jsx-runtime.js';
import { Base, Flex } from '@stepstone-genesis/components';
export const ContentWrapper = ({ children }) => {
    return (_jsx(Base, { sx: { position: 'relative', zIndex: 'zIndex10', height: '100%' }, children: _jsx(Flex, { "data-testid": `fullscreen-content`, flxJustify: ['flex-start', 'center'], flxContent: 'center', flxItems: 'center', sx: { height: '100%' }, pt: 'spaceL', pb: 'spaceXl', px: 'spaceL', children: children }) }));
};
//# sourceMappingURL=ContentWrapper.js.map